'use strict';
import StringHelper from '../../global/StringHelper';
import Icons from '../../siteSearch/components/Icons';
import SuggestType from '../../siteSearch/enums/SuggestType';
import SearchSuggest from '../../siteSearch/model/SearchSuggest';
import UiColors from '../../siteSearch/styles/UiColors';
import UiHelper from '../../siteSearch/ui/UiHelper';
import DomElementBuilder from '../../sxQuery/DomElementBuilder';
import sxQuery from '../../sxQuery/sxQuery';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
import BlockEntryType from '../enums/BlockEntryType';
import CategoryStyle from '../enums/CategoryStyle';
import ImagePosition from '../enums/ImagePosition';
import SuggestionStyle from '../enums/SuggestionStyle';
import SuggestLayoutType from '../enums/SuggestLayoutType';
import DataPointType from '../interface/DataPointType';
import Helper from '../utils/Helper';
const DEFAULT_LAYOUT_CONFIGURATION = {
    type: SuggestLayoutType.List,
    imagePosition: ImagePosition.Left,
    showTitle: true,
    showSnippet: false,
    showUrl: false,
    gridColsSm: 1,
    gridColsMd: 2,
    gridColsLg: 3,
    gridColsXl: 3,
    icon: undefined,
    title: undefined
    // separator: false
};
const ACTIVE_TAB_CLASS_NAME = 'unibox__menu-item--active';
class SuggestionBlock {
    constructor(dataSet, layoutConfiguration, dataPoints, categoryStyle, config, style, interpretedQuery) {
        this.dataSet = dataSet;
        // @ts-ignore
        this.layoutConfiguration = layoutConfiguration !== undefined ? SxQueryUtils.extend(JSON.parse(JSON.stringify(DEFAULT_LAYOUT_CONFIGURATION)), layoutConfiguration) : DEFAULT_LAYOUT_CONFIGURATION;
        this.clusterId = Math.round(100000 * Math.random()).toString();
        this.dataPoints = dataPoints || [];
        this.categoryStyle = categoryStyle;
        this.activeContentGroup = '*';
        this.config = config;
        this.style = style || SuggestionStyle.Standard;
        this.empty = false;
        this.interpretedQuery = interpretedQuery;
    }
    isShowCta() {
        return this.layoutConfiguration.cta !== undefined && this.dataSet.data.length > 0;
    }
    render(highlight, searchQuery, selectCallback, submitCallback, suggestLineCallback, deleteCallback, viewKeyMappings, groupChangeCallback, accentColor, hideHandler, suggestRenderer, numberOfBlocks, templateIncludeGroups) {
        const contentGroup = this.dataSet.data.length > 0 ? this.dataSet.data[0].contentGroup : undefined;
        const clusterTypeId = contentGroup ? ` unibox__cluster--${StringHelper.getSafeKey(contentGroup)}` : '';
        const wrap = sxQuery(`<div class="unibox-n-section unibox__cluster unibox__cluster--type-${this.dataSet.type} unibox__cluster--layout-${this.layoutConfiguration.type} unibox__cluster--style-${this.style}${clusterTypeId}" role="none"></div>`);
        if (contentGroup && this.config.clusterClassMap && this.config.clusterClassMap[StringHelper.getSafeKey(contentGroup)]) {
            wrap.addClass(this.config.clusterClassMap[StringHelper.getSafeKey(contentGroup)]);
        }
        if (this.layoutConfiguration.type === SuggestLayoutType.Grid) {
            const clusterId = `unibox-cluster-${this.clusterId}`;
            wrap.attr('id', clusterId);
            let style = '';
            const breakpoints = [
                { type: 'max', val: 767, cols: this.layoutConfiguration.gridColsSm },
                { type: 'max', val: 991, cols: this.layoutConfiguration.gridColsMd },
                { type: 'min', val: 992, cols: this.layoutConfiguration.gridColsLg },
                { type: 'min', val: 1200, cols: this.layoutConfiguration.gridColsXl }
            ];
            breakpoints.forEach((bp) => {
                const ctaStyle = this.isShowCta() ? `#${clusterId} .unibox__selectable--cta { grid-column: ${bp.cols}; }` : '';
                style += `@media(${bp.type}-width:${bp.val}px){#${clusterId}{grid-template-columns: ${new Array(bp.cols + 1).join('1fr ')};}${ctaStyle}}`;
            });
            wrap.append(`<style type="text/css">${style}</style>`);
        }
        let isFirstRender = true;
        let clusterAriaLabel;
        const renderDataSet = (data) => {
            const oldSelectablesLength = (this.selectables || []).length;
            this.selectables = [];
            const layoutTitle = this.layoutConfiguration.title;
            let lastContentGroup = layoutTitle;
            data.forEach((entry, idx) => {
                let viewKey = viewKeyMappings[entry.contentGroup] !== undefined ? viewKeyMappings[entry.contentGroup] : entry.contentGroup;
                if (numberOfBlocks === 1 && entry.contentGroup === '_') { // do not show other title if there is only a single content group
                    viewKey = '';
                }
                if (viewKey === undefined || viewKey === null || viewKey.length === 0 || this.layoutConfiguration.overrideTitle) {
                    viewKey = layoutTitle;
                }
                if (clusterAriaLabel === undefined && viewKey !== undefined && viewKey !== null && viewKey.length > 0) {
                    clusterAriaLabel = viewKey;
                }
                if (lastContentGroup !== entry.contentGroup) {
                    if (viewKey !== undefined && viewKey !== null && viewKey.length > 0) {
                        wrap.append(`<h2 class="unibox__suggest-heading" role="none">${viewKey}</h2>`);
                        if (this.categoryStyle !== CategoryStyle.Titles) {
                            wrap.find('.unibox__suggest-heading').addClass('unibox-sr-only');
                        }
                    }
                    lastContentGroup = entry.contentGroup;
                }
                let $selectable = this.renderEntry(entry, selectCallback, highlight, searchQuery, deleteCallback, viewKeyMappings, accentColor, submitCallback, hideHandler, suggestRenderer, templateIncludeGroups);
                if (suggestLineCallback !== undefined) {
                    const suggestLineResult = suggestLineCallback($selectable.length > 0 ? $selectable.get()[0].outerHTML : '', entry.contentGroup, idx, entry);
                    if (suggestLineResult !== undefined) {
                        $selectable = sxQuery(suggestLineResult);
                        if (this.dataSet.type === BlockEntryType.SearchHistory) {
                            $selectable.find('.unibox__delete-history').on('click', (e) => {
                                this.onDeleteHistory(e, $selectable, deleteCallback, entry.title);
                            });
                        }
                        $selectable.on('click', (e) => {
                            if (entry.clickHandler !== undefined) {
                                const res = entry.clickHandler();
                                if (res) {
                                    hideHandler();
                                }
                            }
                            else {
                                selectCallback(entry, wrap, e);
                            }
                        });
                    }
                }
                this.selectables.push($selectable);
                wrap.append($selectable);
            });
            if (!isFirstRender) {
                groupChangeCallback(oldSelectablesLength, this.selectables.length);
            }
            isFirstRender = false;
        };
        if (this.categoryStyle === CategoryStyle.Tabs) {
            const groupedEntries = this.dataSet.data.reduce((acc, entry) => {
                acc['*'].push(entry);
                if (entry.contentGroup !== undefined) {
                    if (acc[entry.contentGroup] === undefined) {
                        acc[entry.contentGroup] = [];
                    }
                    acc[entry.contentGroup].push(entry);
                }
                return acc;
            }, { '*': [] });
            const groupKeys = Object.keys(groupedEntries).filter((key) => {
                const viewKey = viewKeyMappings[key] !== undefined ? viewKeyMappings[key] : key;
                return viewKey !== undefined && viewKey.length > 0;
            });
            if (groupKeys.length > 2) { // length === 2 would mean that we have the all results tab + one additional tab containing all results
                const ul = sxQuery('<ul role="tablist" class="unibox__menu-bar"></ul>');
                ul.attr('aria-label', this.config.suggestionsNavigationLabel);
                const buttonsMap = {};
                groupKeys.forEach((key) => {
                    const viewKey = viewKeyMappings[key] !== undefined ? viewKeyMappings[key] : key;
                    const isSelected = this.activeContentGroup === key;
                    const activeClassName = isSelected ? ` ${ACTIVE_TAB_CLASS_NAME}` : '';
                    const navigationButton = sxQuery(`<button type="button" role="tab" class="unibox__menu-item${activeClassName} unibox-n-button" aria-selected="${isSelected}">${viewKey}</button>`);
                    buttonsMap[key] = navigationButton;
                    navigationButton.on('click', (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (this.activeContentGroup !== key) {
                            this.selectables.forEach((selectable) => {
                                selectable.remove();
                            });
                        }
                        this.activeContentGroup = key;
                        Object.keys(buttonsMap).forEach((buttonKey) => {
                            const $el = buttonsMap[buttonKey];
                            if (buttonKey === key) {
                                $el.addClass(ACTIVE_TAB_CLASS_NAME);
                                $el.attr('aria-selected', 'true');
                            }
                            else {
                                $el.removeClass(ACTIVE_TAB_CLASS_NAME);
                                $el.attr('aria-selected', 'false');
                            }
                        });
                        renderDataSet(groupedEntries[key]);
                    });
                    const navigationEntry = sxQuery('<li role="none"></li>');
                    navigationEntry.append(navigationButton);
                    ul.append(navigationEntry);
                });
                wrap.append(ul);
            }
        }
        renderDataSet(this.dataSet.data);
        if (this.isShowCta() && this.dataSet.data.length > 0) {
            const label = (this.layoutConfiguration.cta || '').replace(/#GROUP#/g, this.getResultGroup());
            const $cta = sxQuery(`<button type="button" class="unibox-n-button unibox__selectable unibox__selectable--cta" aria-selected="false" role="option">${label}</button>`);
            $cta.on('click', () => {
                submitCallback($cta, this.getResultGroup());
            });
            this.cta = $cta;
            wrap.append($cta);
        }
        return wrap;
    }
    getResultGroup() {
        return this.dataSet.type === BlockEntryType.ResultGroup ? this.dataSet.data[0].contentGroup : undefined;
    }
    renderEntry(entry, selectCallback, highlight, searchQuery, deleteCallback, viewKeyMappings, accentColor, submitCallback, hideHandler, suggestRenderer, templateIncludeGroups) {
        const additionalClassName = entry.className !== undefined ? ` ${entry.className}` : '';
        let wrap;
        const useSuggestRenderer = suggestRenderer !== undefined && (templateIncludeGroups === undefined || templateIncludeGroups.indexOf(entry.contentGroup) !== -1);
        if (!useSuggestRenderer) {
            const wrapNode = DomElementBuilder.createElement({
                tag: 'div',
                classList: ['unibox-n-section', 'unibox__selectable', additionalClassName],
                attrs: {
                    'aria-selected': 'false',
                    'role': 'option'
                },
                data: {
                    productIdentifier: entry.identifier
                }
            });
            const contentWrap = DomElementBuilder.createElement({
                tag: 'div',
                classList: ['unibox__content-container']
            });
            const title = entry.title;
            if (this.layoutConfiguration.showTitle && title !== undefined) {
                contentWrap.appendChild(DomElementBuilder.createElement({
                    tag: 'h3',
                    classList: ['unibox__selectable-title'],
                    html: highlight ? StringHelper.highlightSearchWords(StringHelper.escapeHtml(title), searchQuery) : title
                }));
            }
            if (this.layoutConfiguration.showUrl && entry.link !== undefined) {
                contentWrap.appendChild(DomElementBuilder.createElement({
                    tag: 'a',
                    attrs: {
                        href: entry.link,
                    },
                    classList: ['unibox__selectable-link'],
                    textContent: entry.link
                }));
            }
            let snippet = entry.snippet;
            if (this.layoutConfiguration.showSnippet && snippet !== undefined) {
                snippet = snippet.split(/\n/g).join(' ');
                contentWrap.appendChild(DomElementBuilder.createElement({
                    tag: 'p',
                    classList: ['unibox__selectable-snippet'],
                    html: highlight ? StringHelper.highlightSearchWords(StringHelper.escapeHtml(snippet), searchQuery) : snippet
                }));
            }
            if ((this.dataPoints.length > 0 || this.config.showAllDataPoints) && entry.dataPoints !== undefined && entry.dataPoints.length > 0) {
                const dataPointsList = DomElementBuilder.createElement({
                    tag: 'ul',
                    classList: ['unibox__selectable-data-points']
                });
                const checkShowFlag = entry.dataPoints.reduce((acc, dp) => {
                    if (acc[dp.key] === undefined) {
                        acc[dp.key] = false;
                    }
                    acc[dp.key] = acc[dp.key] || dp.show;
                    return acc;
                }, {});
                const dataPointsMap = entry.dataPoints.reduce((acc, dataPoint) => {
                    if (dataPoint.type === 'FILTER' || dataPoint.type === 'SORTING') {
                        return acc;
                    }
                    if (acc[dataPoint.key] === undefined) {
                        acc[dataPoint.key] = [];
                    }
                    if (dataPoint.show || !checkShowFlag[dataPoint.key]) {
                        acc[dataPoint.key].push(dataPoint.value);
                    }
                    return acc;
                }, {});
                let dataPointAdded = false;
                const dataPoints = this.config.showAllDataPoints ? Object.keys(dataPointsMap).map((key) => ({ type: DataPointType.KeyValue, key })) : this.dataPoints;
                dataPoints.forEach((dataPoint) => {
                    if (dataPointsMap[dataPoint.key] !== undefined) {
                        dataPointsMap[dataPoint.key].forEach((dp) => {
                            dataPointAdded = true;
                            let inner = `<span class="unibox__selectable-data-point-value">${dp}</span>`;
                            if (dataPoint.type === DataPointType.KeyValue) {
                                inner = `<strong class="unibox__selectable-data-point-key">${dataPoint.key}:</strong> ${inner}`;
                            }
                            dataPointsList.appendChild(DomElementBuilder.createElement({
                                tag: 'li',
                                classList: ['unibox__selectable-data-point', `unibox__selectable-data-point--${dataPoint.type}`],
                                html: inner
                            }));
                        });
                    }
                });
                if (dataPointAdded) {
                    contentWrap.appendChild(dataPointsList);
                }
            }
            if (entry.suggestionHtml !== undefined) {
                contentWrap.appendChild(DomElementBuilder.createElement({
                    tag: 'span',
                    classList: ['unibox__search-content'],
                    html: entry.suggestionHtml
                }));
            }
            const viewKey = viewKeyMappings[entry.contentGroup] !== undefined ? viewKeyMappings[entry.contentGroup] : entry.contentGroup;
            if (this.categoryStyle === CategoryStyle.Chips && viewKey !== undefined && viewKey.length > 0) {
                const categoryButton = DomElementBuilder.createElement({
                    tag: 'button',
                    classList: ['unibox-n-button', 'unibox__selectable-category'],
                    attrs: {
                        type: 'button',
                        title: this.config.submitGroupLabel.replace(/#GROUP_NAME#/g, viewKey)
                    },
                    html: viewKey
                });
                categoryButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    submitCallback(sxQuery(categoryButton), entry.contentGroup);
                });
                const categoryWrap = DomElementBuilder.createElement({
                    tag: 'div',
                    classList: ['unibox__selectable-category-wrap'],
                    children: [categoryButton]
                });
                contentWrap.appendChild(categoryWrap);
            }
            wrapNode.appendChild(contentWrap);
            if (this.dataSet.type === BlockEntryType.SearchHistory) {
                const deleteButton = DomElementBuilder.createElement({
                    tag: 'button',
                    classList: ['unibox__delete-history', 'unibox-n-button'],
                    attrs: {
                        type: 'button',
                        title: this.config.removeSuggestionLabel
                    },
                    children: [Icons.getSvgIconNode(Icons.CROSS, UiColors.FRENCH_GREY, 'unibox__delete-history-icon')]
                });
                deleteButton.addEventListener('click', (e) => {
                    this.onDeleteHistory(e, wrap, deleteCallback, entry.title);
                });
                wrapNode.appendChild(deleteButton);
            }
            wrap = sxQuery(wrapNode);
            let isCol = false;
            const { imagePosition } = this.layoutConfiguration;
            const isQuerySuggestion = this.dataSet.type === BlockEntryType.ResultGroup && entry.contentGroup === 'ss360QuerySuggestions';
            if (imagePosition !== ImagePosition.None && ((entry.image !== undefined && entry.image !== null) || this.layoutConfiguration.placeholderImage !== undefined)) {
                const image = entry.image || this.layoutConfiguration.placeholderImage;
                isCol = imagePosition === ImagePosition.Top || imagePosition === ImagePosition.Bottom;
                const img = DomElementBuilder.createElement({
                    tag: 'img',
                    classList: ['unibox__selectable-image', UiHelper.isDocIcon(image) ? 'unibox__selectable-image--doc-icon' : ''],
                    attrs: {
                        src: image,
                        alt: '',
                        'aria-hidden': 'true',
                        role: 'presentation'
                    }
                });
                const imgWrap = DomElementBuilder.createElement({
                    tag: 'div',
                    classList: ['unibox__selectable-image-container', `unibox__selectable-image-container--${imagePosition}`],
                    children: [
                        img
                    ]
                });
                if (imagePosition === ImagePosition.Bottom || imagePosition === ImagePosition.Right) {
                    wrap.append(imgWrap);
                }
                else {
                    wrap.prepend(imgWrap);
                }
                wrap.addClass('unibox__selectable--has-image');
                img.addEventListener('error', () => {
                    sxQuery(img).hide();
                });
            }
            else if ((this.layoutConfiguration.icon || '').length > 0 || this.dataSet.type === BlockEntryType.SearchHistory || isQuerySuggestion) {
                const { icon } = this.layoutConfiguration;
                const iconWrap = DomElementBuilder.createElement({
                    tag: 'div',
                    classList: ['unibox__selectable-icon-container'],
                    attrs: {
                        role: 'presentation'
                    }
                });
                if (icon === 'ss360:search' || icon === 'zoovu:search' || isQuerySuggestion) {
                    iconWrap.appendChild(Icons.getSvgIconNode(Icons.MAGNIFIER, UiColors.GREY_TEXT, 'z-search-block', 16, 16));
                }
                else if (icon === 'ss360:history' || icon === 'zoovu:history' || this.dataSet.type === BlockEntryType.SearchHistory) {
                    iconWrap.appendChild(Icons.getSvgIconNode(Icons.HISTORY, UiColors.GREY_TEXT, 'z-search-block', 16, 16));
                }
                else {
                    try {
                        sxQuery(iconWrap).append(icon);
                    }
                    catch (err) {
                        // ccl
                    }
                }
                wrap.prepend(iconWrap);
            }
            if (isCol) {
                wrap.addClass('unibox__selectable--col');
            }
        }
        else {
            if (entry.title !== undefined && entry.title !== '') {
                entry.highlightedName = StringHelper.highlightSearchWords(entry.title, searchQuery);
            }
            if (entry.snippet !== undefined && entry.snippet !== '') {
                entry.highlightedContent = StringHelper.highlightSearchWords(entry.snippet, searchQuery);
            }
            // @ts-ignore
            const suggestObj = Object.assign(Object.assign({}, entry), { name: entry.title, type: SuggestType.HTML, content: entry.snippet });
            wrap = suggestRenderer.render(new SearchSuggest(suggestObj), this.activeContentGroup, false, true);
        }
        wrap.on('click', (e) => {
            if (entry.clickHandler !== undefined) {
                const res = entry.clickHandler();
                if (res) {
                    hideHandler();
                }
            }
            else {
                selectCallback(entry, wrap, e);
            }
        });
        return wrap;
    }
    onDeleteHistory(e, wrap, deleteCallback, title) {
        e.stopPropagation();
        e.preventDefault();
        wrap.remove();
        const idx = this.selectables.indexOf(wrap);
        this.selectables.splice(idx, 1);
        if (this.selectables.length === 0 && this.cta !== undefined) {
            this.cta.remove();
        }
        deleteCallback(title);
    }
    highlight(idx) {
        if (this.isCta(idx)) { // cta is focused
            Helper.addHighlight(this.cta);
            return;
        }
        const selectable = (this.selectables || [])[idx];
        if (selectable !== undefined) {
            Helper.addHighlight(selectable);
        }
    }
    removeHighlight() {
        (this.selectables || []).forEach((selectable) => {
            Helper.removeHighlight(selectable);
        });
        if (this.cta !== undefined) {
            Helper.removeHighlight(this.cta);
        }
    }
    length() {
        return this.dataSet.data.length + (this.isShowCta() ? 1 : 0);
    }
    isCta(idx) {
        return this.isShowCta() && this.cta !== undefined && idx === (this.selectables || []).length;
    }
    get(idx) {
        return this.dataSet.data[idx];
    }
    getSelectable(idx) {
        return this.selectables[idx];
    }
    getColumnCount(staticLayout = false) {
        if (!staticLayout && this.dataSet.data.length === 0 && !this.empty) {
            return 0;
        }
        // 1=respect css; 2=stretch
        return this.layoutConfiguration.type === SuggestLayoutType.HorizontalList ? 2 : 1;
    }
    setEmpty(empty) {
        this.empty = empty;
    }
}
export default SuggestionBlock;
